export default __webpack_public_path__ + "static/lframe-better-things-0d799390fb06a50ce364e3997f684712.png";